import React, { FC } from "react";

import { useMediaQuery } from "@mui/material";

import { Sort } from "@/components/atoms";
import { Table } from "@/components/molecules";
import { Document, SearchDocumentsSortProperty } from "@/shared/domain";
import { useMediaDisplayer } from "@/shared/hooks";
import { getLink } from "@/shared/utils";

import DocumentTableItemDesktop from "./DocumentTableItemDesktop/DocumentTableItemDesktop";
import DocumentTableItemMobile from "./DocumentTableItemMobile/DocumentTableItemMobile";
import { documentTableColumnsDesktop, documentTableColumnsMobile } from "./utils";

export type DocumentTableProps = {
    documents: Document[];
    orderBy: Sort<SearchDocumentsSortProperty>;
    handleSort: (orderBy: SearchDocumentsSortProperty) => void;
};

const DocumentTable: FC<DocumentTableProps> = ({ documents, handleSort, orderBy }) => {
    const isSmallScreen = !useMediaQuery("(min-width:768px)");
    const { displayFullMode } = useMediaDisplayer();

    const openDocumentDisplay = (document: Document) => {
        const url = getLink(document, "content")?.href;
        displayFullMode({ title: document.filename, type: document.documentExtension.toLowerCase(), url });
    };

    const renderItem = (document: Document) => {
        if (isSmallScreen) {
            return (
                <DocumentTableItemMobile
                    document={document}
                    key={document.id}
                    onClick={() => openDocumentDisplay(document)}
                />
            );
        }
        return (
            <DocumentTableItemDesktop
                document={document}
                key={document.id}
                onClick={() => openDocumentDisplay(document)}
            />
        );
    };

    return (
        <Table<Document, SearchDocumentsSortProperty>
            columns={isSmallScreen ? documentTableColumnsMobile : documentTableColumnsDesktop}
            handleSort={handleSort}
            orderBy={orderBy}
            items={documents}
            renderItem={renderItem}
        />
    );
};

export default DocumentTable;
